// import React from 'react'
// import Home from '../../components/Home';
// import About from '../../components/About';
// import Services from '../../components/Services';
// import Projects from '../../components/Projects';
// import Contact from '../../components/Contact';
// import Footer from '../../components/Footer';
// import Header from '../../components/Header';


// // const Home0 = ({ onLoginSuccess }) => {
// const Home0 = () => {
//   return (
//     <div>
//       <Header />
//             <main className="main">
                
//               <Home />
//               {/* <About onLoginSuccess={onLoginSuccess}/> */}
//               <About />
//               <Services />
//               <Projects />
//               <Contact />
              
//             </main>
//              <Footer />

//     </div>
//   )
// }

// export default Home0

import React from 'react'
import Home from '../../components/Home';
import About from '../../components/About';
import Services from '../../components/Services';
import Projects from '../../components/Projects';
import Contact from '../../components/Contact';
import Footer from '../../components/Footer';
import Header from '../../components/Header';


const Home0 = ({ onLoginSuccess }) => {
  return (
    <div>
      <Header />
            <main className="main">
                
              <Home />
              <About  onLoginSuccess={onLoginSuccess}/>
              <Services />
              <Projects />
              <Contact />
              
            </main>
             <Footer />

    </div>
  )
}

export default Home0
